import React from "react";
import { useObserver } from "mobx-react";
import { DropdownBtnOptions, Props } from "./CommentBox";
import { CommentBoxStore } from "./CommentBoxStore";
import { ControlsRow } from "@common/ControlsRow";
import { Button, makeStyles } from "@material-ui/core";
import WithTooltip from "@components/WithTooltip";
import locale from "@bonliva-crm/locale";
import EmailIcon from "@material-ui/icons/Email";
import FavoriteIcon from "@material-ui/icons/Favorite";
import CloudUpload from "@material-ui/icons/CloudUpload";
import PhoneMissedIcon from "@material-ui/icons/PhoneMissed";
import { CommentButton } from "./CommentButton";

type RightControlProps = {
  store: CommentBoxStore;
  commentProps: Props<any>;
};

export function RightControl(props: RightControlProps) {
  const {
    store,
    commentProps: {
      withNoAnswer,
      withUpload,
      onEmail,
      onUpload,
      uploadDisabled,
      withButtons
    }
  } = props;

  const classes = useStyle({});

  return useObserver(() => {
    const { valid, disabled, isSubmitting, dirty } = store;
    const actionDisabled = disabled || isSubmitting || !valid || !dirty;
    const disableUpload = disabled || isSubmitting || uploadDisabled;
    const notRemainder = store.dropdownBtnIndex !== DropdownBtnOptions.Reminder;

    const buttonList = [
      {
        dataTest: "CommentBoxInterest",
        onClick: store.onInterest,
        label: locale.interest,
        icon: <FavoriteIcon />,
        disabled: disabled || isSubmitting,
        isDisplayed: withButtons.includes("interest") && notRemainder
      },
      {
        dataTest: "CommentBoxEmail",
        onClick: onEmail,
        label: locale.Email,
        icon: <EmailIcon />,
        disabled: false,
        isDisplayed: onEmail && notRemainder
      },
      {
        dataTest: "CommentBoxUpload",
        onClick: onUpload,
        label: locale.UploadFile,
        icon: <CloudUpload />,
        disabled: disableUpload,
        isDisplayed: withUpload && notRemainder
      },
      {
        dataTest: "NoanswerButton",
        onClick: store.onNoAnswer,
        label: locale.NoAnswer,
        icon: <PhoneMissedIcon />,
        disabled: disabled || isSubmitting,
        isDisplayed: withNoAnswer && notRemainder
      }
    ].filter((v) => v.isDisplayed);

    return (
      <ControlsRow>
        {buttonList.map(({ label, onClick, dataTest, icon, disabled }) => (
          <div key={dataTest}>
            <Button
              onClick={onClick}
              data-test={dataTest}
              disabled={disabled}
              classes={{ root: classes.iconButton, label: classes.iconButtonLabel }}
            >
              {icon}
              <span>{label}</span>
            </Button>
          </div>
        ))}

        <WithTooltip
          className={classes.commentDropDown}
          title={actionDisabled ? locale.FillSomething(locale.Comment) : null}
        >
          <CommentButton store={store} commentProps={props.commentProps} />
        </WithTooltip>
      </ControlsRow>
    );
  });
}

const useStyle = makeStyles((theme) => ({
  commentDropDown: {
    padding: 7
  },
  iconButtonLabel: {
    whiteSpace: "nowrap",
    flexDirection: "column",
    textTransform: "none"
  },
  iconButton: {
    color: theme.palette.text.secondary
  }
}));
